/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

/**
 * How fallbackData was computed: 'keyword' = the same keyword search without the location filter (matches from other areas, nearest first); 'popular' = global top activities by booking count. Absent when fallbackData is absent.
 */
export enum ActivitySearchResultsAllOfFallbackKind {
  keyword = 'keyword',
  popular = 'popular'
}
